/**
 * Fade-in on scroll utility using GSAP and ScrollTrigger
 *
 * Usage:
 * Add class="fade-in" to any element you want to animate on scroll
 *
 * Optional data attributes:
 * - data-fade-delay: delay in seconds (default: 0)
 * - data-fade-duration: animation duration in seconds (default: 1)
 * - data-fade-y: distance to move on Y axis in pixels (default: 50)
 * - data-fade-start: scroll position to start (default: "top 80%")
 *
 * Examples:
 * <div class="fade-in">Fades in with defaults</div>
 * <div class="fade-in" data-fade-delay="0.2" data-fade-y="100">Custom animation</div>
 */

(function() {
  'use strict';

  function initFadeIn() {
    // Check if GSAP is loaded
    if (typeof gsap === 'undefined') {
      console.error('GSAP is not loaded. Please include GSAP library before this script.');
      return;
    }

    // Register ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    const fadeElements = document.querySelectorAll('.fade-in');

    fadeElements.forEach((element) => {
      const delay = parseFloat(element.dataset.fadeDelay) || 0;
      const duration = parseFloat(element.dataset.fadeDuration) || 1;
      const yDistance = parseInt(element.dataset.fadeY) || 50;
      const start = element.dataset.fadeStart || 'top 80%';

      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: start,
          toggleActions: 'play none none none',
          // Uncomment for debugging:
          // markers: true
        },
        opacity: 0,
        y: yDistance,
        duration: duration,
        delay: delay,
        ease: 'power2.out'
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }
})();
